import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function DocumentIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="24"
        viewBox="0 0 20 24"
        fill="none"
      >
        <path
          d="M11 1H11.3787C11.7765 1 12.158 1.15804 12.4393 1.43934L18.5607 7.56066C18.842 7.84196 19 8.2235 19 8.62132V9M11 1H2.5C1.67157 1 1 1.67157 1 2.5V21.5C1 22.3284 1.67157 23 2.5 23H17.5C18.3284 23 19 22.3284 19 21.5V9M11 1V7.5C11 8.32843 11.6716 9 12.5 9H19"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
        />
      </svg>
    </SvgIcon>
  );
}
